// src/components/layout/SyncAIIntro.js
import React, { useState, useRef } from 'react';
import { Box, Button, Typography, IconButton } from '@mui/material';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';

// 인트로 화면에서 "SyncAI 가기"를 누르면 보여지는 SyncAI 소개 영상 화면
// 영상 파일은 public/syncai-intro.mp4 에 넣어주세요 (기존 'SyncAI 소개.mp4' 파일을 이 이름으로 바꿔서 넣으면 됩니다).
const SyncAIIntro = ({ onEnter, onBack }) => {
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);

  const toggleSound = () => {
    const newMuted = !isMuted;
    if (videoRef.current) {
      videoRef.current.muted = newMuted;
      if (!newMuted) {
        videoRef.current.volume = 1;
      }
    }
    setIsMuted(newMuted);
  };

  return (
    <Box sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      overflow: 'hidden',
      zIndex: 9999,
      backgroundColor: 'black'
    }}>
      <video
        ref={videoRef}
        autoPlay
        loop
        muted={isMuted}
        playsInline
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          objectFit: 'cover'
        }}
        src="/syncai-intro.mp4"
      >
        브라우저가 비디오 태그를 지원하지 않습니다.
      </video>

      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.4)'
        }}
      >
        {/* 우측 상단 버튼 그룹 */}
        <Box
          sx={{
            position: 'absolute',
            top: 24,
            right: 24,
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'flex-end',
            gap: 1.5,
            maxWidth: { xs: 'calc(100vw - 48px)', sm: 'none' }
          }}
        >
          <Button
            variant="outlined"
            size="small"
            onClick={onBack}
            sx={{
              fontSize: '0.8rem',
              padding: '6px 14px',
              borderRadius: '12px',
              color: 'white',
              borderColor: 'rgba(255,255,255,0.6)',
              backgroundColor: 'rgba(255,255,255,0.08)',
              '&:hover': {
                borderColor: 'white',
                backgroundColor: 'rgba(255,255,255,0.18)'
              }
            }}
          >
            이전으로
          </Button>

          <Button
            variant="contained"
            size="small"
            onClick={onEnter}
            sx={{
              fontSize: '0.8rem',
              padding: '6px 12px',
              borderRadius: '12px'
            }}
          >
            홈 메뉴 가기
          </Button>
        </Box>

        {/* 소리 켜기/끄기 버튼 */}
        <IconButton
          onClick={toggleSound}
          aria-label={isMuted ? '소리 켜기' : '소리 끄기'}
          sx={{
            position: 'absolute',
            bottom: 24,
            left: 24,
            color: 'white',
            backgroundColor: 'rgba(0,0,0,0.4)',
            '&:hover': { backgroundColor: 'rgba(0,0,0,0.6)' }
          }}
        >
          {isMuted ? <VolumeOffIcon /> : <VolumeUpIcon />}
        </IconButton>

        {/* 좌측 상단 텍스트 컨테이너 */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            textAlign: 'left',
            color: 'white',
            p: { xs: 4, md: 8 }
          }}
        >
          <Typography
              variant="h4"
              component="h1"
              gutterBottom
              sx={{
                fontWeight: 'bold',
                textShadow: '2px 2px 8px rgba(0,0,0,0.8)'
              }}>
            SyncAI
          </Typography>

          <Typography
              variant="body1"
              sx={{
                  textShadow: '1px 1px 4px rgba(0,0,0,0.7)'
              }}
          >
              모든 시스템을 연결하고, AI가 가치를 더합니다
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default SyncAIIntro;
